/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameIconEntry } from './GameIconEntry';
import {
    GameIconEntryFromJSON,
    GameIconEntryFromJSONTyped,
    GameIconEntryToJSON,
    GameIconEntryToJSONTyped,
} from './GameIconEntry';

/**
 * 
 * @export
 * @interface GameIconsResponse
 */
export interface GameIconsResponse {
    /**
     * 
     * @type {Array<GameIconEntry>}
     * @memberof GameIconsResponse
     */
    games: Array<GameIconEntry>;
}

/**
 * Check if a given object implements the GameIconsResponse interface.
 */
export function instanceOfGameIconsResponse(value: object): value is GameIconsResponse {
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function GameIconsResponseFromJSON(json: any): GameIconsResponse {
    return GameIconsResponseFromJSONTyped(json, false);
}

export function GameIconsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameIconsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'games': ((json['games'] as Array<any>).map(GameIconEntryFromJSON)),
    };
}

export function GameIconsResponseToJSON(json: any): GameIconsResponse {
    return GameIconsResponseToJSONTyped(json, false);
}

export function GameIconsResponseToJSONTyped(value?: GameIconsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'games': ((value['games'] as Array<any>).map(GameIconEntryToJSON)),
    };
}

